module.exports = __webpack_public_path__ + "static/media/math.d22b7c78.svg";